<template lang="pug">
v-list-item(
  :disabled="disabled"
  @click="$emit('perform', { link: action })"
)
  v-list-item-avatar.mr-2
    v-icon {{ action.icon || 'mdi-menu' }}

  v-list-item-content
    v-list-item-title.text-no-wrap {{ action.title || action.verb || action.name || `{ ${action.eref} }` }}

</template>

<script>
import { selectClass, selectColor } from '@/helpers/styles'

export default {
  props: {
    action: Object,
  },

  computed: {
    disabled () {
      return !!this.action.disabled
    },
  },

  methods: {
    style () {
      return selectClass(this.action.style)
    },

    color() {
      const color = this.action?.color
      return color ? color : selectColor(this.action?.style)
    },
  },
}
</script>
